import { FormikErrors } from "formik";

export default function renderError(error: string | string[] | FormikErrors<any> | FormikErrors<any>[]) {
  if (typeof error === 'string') {
    return error;
  }
  if (Array.isArray(error)) {
    return error.map(e => (typeof e === 'string' ? e : JSON.stringify(e))).join(', ');
  }
  if (typeof error === 'object' && error !== null) {
    return JSON.stringify(error);
  }
  return null;
}
